import humboldt from "@assets/logos/humboldt.png";

export const uiText = {
  uiTxt: {
    links: {
      citation: "Citese",
      contact: "Contacto",
      tos: "Términos",
    },
    collaboratorsTitle: "Colaboradores",
  },
  IAVH: {
    img: humboldt,
    name: "Alexander von Humboldt",
    tag: "Instituto de Investigación de Recursos Biológicos",
    contact: "biotablero@humboldt.org.co",
    url: "http://www.humboldt.org.co/es/",
    linkAlt: "Ir al sitio web",
  },
  citationClipboard:
    "Instituto de Investigación de Recursos Biológicos Alexander von Humboldt. (2019). BioTablero, cifras e indicadores sobre biodiversidad. biotablero.humboldt.org",
  tosTooltip: "Ver términos y condiciones",
  citationTooltip:
    'La siguiente citación será copiada al portapapeles: "Instituto de Investigación de Recursos Biológicos Alexander von Humboldt. (2019). BioTablero, cifras e indicadores sobre biodiversidad. biotablero.humboldt.org"',
};
